// Helper function to normalize values for sorting
// Currently used in Max Report to sort numeric and time values
// Converts time strings (HH:MM:SS.mm, HH:MM:SS, MM:SS.mm, MM:SS, SS.mm) to seconds,
// numeric strings to numbers, and handles special values like '--'
const normalizeMaxValForSort = (value) => {
  // Handle null, undefined, empty string, or special placeholder values
  if (!value || value === '--' || value === '') {
    return null;
  }

  // Convert to string for pattern matching
  const strValue = String(value).trim();

  // Check if it's a time string with hours (format: HH:MM:SS.mm or HH:MM:SS)
  // Check this first since it has 3 colons and is more specific
  const timeWithHoursPattern = /^(\d+):(\d{1,2}):(\d{1,2})(?:\.(\d+))?$/;
  const timeWithHoursMatch = strValue.match(timeWithHoursPattern);
  if (timeWithHoursMatch) {
    const hours = parseInt(timeWithHoursMatch[1], 10);
    const minutes = parseInt(timeWithHoursMatch[2], 10);
    const seconds = parseInt(timeWithHoursMatch[3], 10);
    const milliseconds = timeWithHoursMatch[4] ? parseFloat(`0.${timeWithHoursMatch[4]}`) : 0;
    return (hours * 3600) + (minutes * 60) + seconds + milliseconds;
  }

  // Check if it's a time string with minutes and seconds (format: MM:SS.mm or MM:SS)
  const timeMinutesSecondsPattern = /^(\d+):(\d{1,2})(?:\.(\d+))?$/;
  const timeMinutesSecondsMatch = strValue.match(timeMinutesSecondsPattern);
  if (timeMinutesSecondsMatch) {
    const minutes = parseInt(timeMinutesSecondsMatch[1], 10);
    const seconds = parseInt(timeMinutesSecondsMatch[2], 10);
    const milliseconds = timeMinutesSecondsMatch[3] ? parseFloat(`0.${timeMinutesSecondsMatch[3]}`) : 0;
    return (minutes * 60) + seconds + milliseconds;
  }

  // Check if it's a time string in SS.mm format (seconds.milliseconds, no minutes)
  // Only treat as time if it has 1-2 digits before decimal and value is < 60 seconds
  // This avoids treating regular decimal numbers as times
  const timeSecondsPattern = /^(\d{1,2})\.(\d+)$/;
  const timeSecondsMatch = strValue.match(timeSecondsPattern);
  if (timeSecondsMatch) {
    const totalSeconds = parseFloat(strValue);
    // Only treat as time if it's less than 60 seconds (reasonable for SS.mm format)
    if (totalSeconds < 60) {
      return totalSeconds;
    }
  }

  // Try to parse as a number
  const numValue = Number(strValue);
  if (!Number.isNaN(numValue) && strValue !== '') {
    return numValue;
  }

  // If it's not a number or time, return as-is for string comparison
  return strValue;
};

export default normalizeMaxValForSort;
